var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wave",rawName:"v-wave"}],staticClass:"button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('svgicon',{attrs:{"src":_vm.icon,"height":24}}):[_vm._v(_vm._s(_vm.text))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }